import React, { PureComponent } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Icon } from '../Icon';
import { rotate360Animation } from '../util/keyframes';

const StyledIcon = styled(Icon).attrs({
  role: 'img',
  'aria-hidden': false,
})`
  order: 1;
  text-decoration: none !important;
  cursor: ${p => (p.loading ? 'progress' : 'pointer')};
  height: 16px;
  width: 16px;
  fill: currentColor;
`;

const LinkWrapper = styled.a`
  display: ${p => (p.inline ? 'inline-flex' : 'flex')};
  justify-content: flex-start;
  align-items: center;
  color: ${p => p.theme.colors.primary};
  fill: ${p => p.theme.colors.primary};
  font-family: ${p => p.theme.font}, 'Helvetica Neue', Helvetica, sans-serif;
  &:hover {
    cursor: pointer;
    color: ${p => p.theme.colors.secondary};
    fill: ${p => p.theme.colors.secondary};
  }
`;

const Text = styled.span`
  order: ${p => (p.right ? '0' : '2')};
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: 0.3px;
  text-decoration: ${p => (p.underline ? 'underline' : 'none')};
  margin-${p => (p.right ? 'right' : 'left')}: 5px;
  overflow: hidden;
  white-space: nowrap;
  cursor: ${p => (p.loading ? 'progress' : 'pointer')};
`;

class Link extends PureComponent {
  render() {
    const { icon, loading, right, underline, children, ...props } = this.props;
    return (
      <LinkWrapper {...props}>
        {!right && icon && <StyledIcon icon={icon} aria-label="icon" />}
        <Text
          right={right}
          loading={loading ? 'true' : undefined}
          underline={underline}
        >
          {children}
        </Text>
        {right && icon && <StyledIcon icon={icon} aria-label="icon" />}
      </LinkWrapper>
    );
  }
}

Link.defaultProps = {
  right: false,
  underline: false,
  inline: false,
  loading: false,
};

Link.propTypes = {
  /**
   * The icon to display in the link
   */
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /**
   * Whether the icon should be displayed on the right
   */
  right: PropTypes.bool,
  /**
   * Whether the link is in a loading state
   */
  loading: PropTypes.bool,
  /**
   * The children to render inside the link
   */
  children: PropTypes.node.isRequired,
};

export default Link;
